var utils  = require('./utils');

var ocm = ( function( $ ) {

	var viewport = utils.viewport_size();
	var $document = $( document );
	var $html = $( 'html' );
	var $ocm = false;

	var transition_event = 'transition';

	var _init = function() {
		viewport = utils.viewport_size();

		transition_event = utils.which_transition_event();

		$ocm = $( '#off-canvas-menu' );

		$( '.navbar-toggle' ).on( 'click', _ocm_toggle_click_event );
		$ocm.find( '.close' ).on( 'click', _ocm_close_click_event );

		$( window ).on( 'debouncedresize', _smart_resize_event );

		// $( window ).swipe( {
		// 	swipeLeft: _swipe_left_event,
		// 	swipeRight: _swipe_right_event,
		// 	threshold:0,
		// 	fingers:'all'
		// });
	};

	var _swipe_left_event = function( event ) {
		if ( $html.hasClass( 'ocm-right' ) ) {
			open_ocm();
		} else {
			close_ocm();
		}
	};

	var _swipe_right_event = function( event ) {
		if ( $html.hasClass( 'ocm-right' ) ) {
			close_ocm();
		} else {
			open_ocm();
		}
	};

	var _smart_resize_event = function( event ) {
		viewport = utils.viewport_size();

		if ( viewport.width >= 768 ) {
			$html.removeClass( 'ocm-open' );
		}
	};

	var _ocm_close_click_event = function( event ) {
		close_ocm();

		return false;
	};

	var _ocm_toggle_click_event = function( event ) {
		if ( $html.hasClass( 'ocm-open' ) ) {
			close_ocm();
		} else {
			open_ocm();
		}

		return false;
	};

	var open_ocm = function() {
		setTimeout( _start_open_ocm, 25 );
	};

	var _start_open_ocm = function() {
		$html.addClass( 'ocm-open' );
		$document.on( 'click', _body_click_event );
	};

	var close_ocm = function() {
		setTimeout( function () {
			_start_close_ocm();
		}, 25 );
	};

	var _start_close_ocm = function() {
		$document.off( 'click', _body_click_event );

		$ocm.on( transition_event , _ocm_closed_event );

		$html.addClass( 'ocm-closing' );
		$html.removeClass( 'ocm-open' );
	};

	var _ocm_closed_event = function( event ) {
		$html.removeClass( 'ocm-closing' );

		$( this ).off( event );
	};

	var _body_click_event = function( event ) {
		if ( $( event.target ).closest( '#off-canvas-menu' ).length == 0 ) {
			close_ocm();
		}
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = ocm;